module.exports = __webpack_public_path__ + "img/2.69a939fb.jpg";